import React from "react";
import { useLocation, Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../Services/Store";
import NavbarView from "../Navigation/NavbarView";
import TaglineMarquee from "../Navigation/TaglineMarquee";
import { useAuth } from "../Contexts/AuthContext";

const Main = () => {
  const location = useLocation();
  const { authLoading } = useAuth();
  const user = useSelector((state: RootState) => state.auth.user);

  const hideNavbarOn = [
    "/login",
    "/register",
    "/verifyOtp",
    "/signuprequest",
    "/forgotpassword",
    "/resetPassword",
  ];
  const showNavbar = !hideNavbarOn.includes(location.pathname);

  if (authLoading) {
    return (
      <div style={{ width: "100%", height: "100vh", display: "flex",
        alignItems: "center", justifyContent: "center", fontSize: 18, color: "#555" }}>
        Loading…
      </div>
    );
  }

  return (
    <div>
      {showNavbar && (
        <>
          <TaglineMarquee />       
          <NavbarView user={user} />
        </>
      )}
      <ToastContainer position="top-center" autoClose={1800} style={{ zIndex: 12000 }} />
      <Outlet />
    </div>
  );
};

export default Main;
